import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {OrganisationService} from '../../../shared/services/organisation.service';
import {GlobalService} from '../../../shared/services/global.service';
import {FooterComponent} from '../../footer/footer.component';
import {HeaderComponent} from '../../header/header.component';
import {MatCardModule} from '@angular/material/card';
import {NgClass, NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {AuthService} from '../../../shared/services/auth.service';
import {AlertService} from '../../../shared/services/alert.service';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
  selector: 'app-organization-register',
  templateUrl: './organization-register.component.html',
  imports: [
    ReactiveFormsModule,
    FooterComponent,
    HeaderComponent,
    MatCardModule,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    NgClass
  ],
  styleUrls: ['./organization-register.component.scss'],
  standalone: true,
  providers: [GlobalService, OrganisationService, AuthService, AlertService]
})
export class OrganizationRegisterComponent implements OnInit {
  @ViewChildren('otp1, otp2, otp3, otp4, otp5, otp6') otpInputs!: QueryList<ElementRef>;
  registerForm: FormGroup = new FormGroup({});
  otpForm: FormGroup = new FormGroup({});
  submitted: any = false;
  signInParams: any = {};
  status: any = true;
  registerFormValid = false;
  submitted_loader: any = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private globalService: GlobalService,
    private alertService: AlertService) {
    this.checkUserLogin();
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.registerForm = this.fb.group({
      'organisation_name': ['',],
      'name': ['', Validators.required],
      'email': ['', Validators.required],
      'contact': ['', Validators.required],
      'username': ['', Validators.required],
      'password': ['', Validators.required],
      'confirm_password': ['', Validators.required],
      'acceptTerms': ['', Validators.required]
    });
    this.otpForm = this.fb.group({
      'first_key': ['', Validators.required],
      'second_key': ['', Validators.required],
      'third_key': ['', Validators.required],
      'fourth_key': ['', Validators.required],
      'fifth_key': ['', Validators.required],
      'sixth_key': ['', Validators.required]
    });
    this.registerForm.controls['acceptTerms'].setValue(true);
  }

  checkUserLogin(): void {
    if (localStorage.getItem('accessToken')) {
      this.router.navigateByUrl('/home');
    }
  }

  registerFormStatus() {
    this.registerFormValid = !!(this.registerForm.valid && this.registerForm.value.acceptTerms);
  }
  keepChecked(event: Event): void {
    this.alertService.showErrors('You must accept the terms and conditions to register your organization');
    event.preventDefault();
  }

  otp(): void {
    if (!this.registerForm.valid || this.registerForm.value.acceptTerms == false) {
      this.registerFormValid = false;
      return;
    }
    if (this.registerForm.value && this.registerForm.value.username && this.registerForm.value.username.length < 6) {
      this.alertService.showErrors('Username must be atleast 6 characters long');
      return;
    }
    if (this.registerForm.value && this.registerForm.value.password && this.registerForm.value.password.length < 6) {
      this.alertService.showErrors('Password must be atleast 6 characters long');
      return;
    }
    if (this.registerForm.value.password !== this.registerForm.value.confirm_password) {
      this.alertService.showErrors('Password and Confirm Password are not same');
      return;
    }
    const params: {} = {
      'organisation_name': (this.registerForm && this.registerForm.getRawValue() && this.registerForm.getRawValue().organisation_name) ? this.registerForm.getRawValue().organisation_name : '',
      'name': (this.registerForm && this.registerForm.getRawValue() && this.registerForm.getRawValue().name) ? this.registerForm.getRawValue().name : '',
      'email': (this.registerForm && this.registerForm.getRawValue() && this.registerForm.getRawValue().email) ? this.registerForm.getRawValue().email : '',
      'contact': (this.registerForm && this.registerForm.getRawValue() && this.registerForm.getRawValue().contact) ? this.registerForm.getRawValue().contact : '',
      'username': (this.registerForm && this.registerForm.getRawValue() && this.registerForm.getRawValue().username) ? this.registerForm.getRawValue().username : '',
      'password': (this.registerForm && this.registerForm.getRawValue() && this.registerForm.getRawValue().password) ? this.registerForm.getRawValue().password : ''
    };
    this.authService.otp(params).subscribe((data) => {
      if (data && data.decoded_otp) {
        this.signInParams = params;
        this.signInParams.decoded_otp = data.decoded_otp;
        this.status = false;
      }
    }, error => {
      this.alertService.showErrors(error.error.message);
    });

  }

  signIn(): void {
    this.submitted = true;
    this.submitted_loader = true;
    this.signInParams.otp = (this.otpForm && this.otpForm.getRawValue()) ? this.otpForm.getRawValue().first_key + this.otpForm.getRawValue().second_key + this.otpForm.getRawValue().third_key + this.otpForm.getRawValue().fourth_key + this.otpForm.getRawValue().fifth_key + this.otpForm.getRawValue().sixth_key : null;
    this.authService.register(this.signInParams).subscribe(data => {
        if (data && data.id) {
          this.globalService.setAccessToken(data.token);
          this.globalService.setSelf({
            'name': data.name,
            'email': data.email,
            'contact': data.contact,
            'user_id': data.id,
            'username': data.username,
            'user_type': data.user_type,
            'organisation_id': data.organisation_id
          });
          this.otpForm.reset();
          this.router.navigateByUrl('/home');
        }
      }, error => {
        this.submitted = false;
      this.submitted_loader = false;
        if (error && error['error'] && error['error']['message']) {
          this.alertService.showErrors(error.error.message);
        }
      }
    );
  }

  moveFocus(currentKey: any, nextInput: ElementRef | any) {
    if (currentKey.value && nextInput !== null) {
      nextInput.focus();
    }
  }

  goBack() {
    this.status = true;
  }
}
